import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <Container sx={{ textAlign: 'center', paddingTop: '100px' }}>
            <Typography variant='h2' component='h1' gutterBottom>
                404
            </Typography>
            <Typography variant='h5' component='p' gutterBottom>
                Oops! The page you’re looking for doesn’t exist.
            </Typography>
            <Box sx={{ marginTop: '20px' }}>
                <Button variant='contained' color='primary' component={Link} to='/'>
                    Go Back Home
                </Button>
            </Box>
        </Container>
    );
};

export default NotFound;
